import { jsxs as v, jsx as l } from "react/jsx-runtime";
const o = (r) => /* @__PURE__ */ v(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m31.384 41.59-3.917 1.05 1.05 3.917 3.916-1.05-1.05-3.916Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M63.938 18.416v-4.543l-10.776 5.803-.13.07-.13-.07L33.895 9.442 32 8.422l-1.896 1.02-19.005 10.234-.13.07-.131-.07-11.107-5.98v4.542l9.21 4.96v27.776h-9.21v4h13.21v-.008c.083.005.166.008.25.008h12.266V35.284h13.086V54.974h25.396v-4h-8.88V23.198l8.88-4.782ZM51.005 50.974h-8.462v-19.69H21.457v19.69H13.19a.195.195 0 0 1-.195-.195V23.198L32 12.964l19.005 10.234v27.776Z"
        }
      )
    ]
  }
);
export {
  o as Terraced
};
